import React from 'react';
import {Route, RouteProps, Redirect} from 'react-router-dom';
import {useIsAuthenticated} from '../hooks/auth';

export const PrivateRoute: React.FC<RouteProps> = ({component: Component, ...rest}) => {
  const isAuth = useIsAuthenticated();
  if (!Component) return null;
  return <Route {...rest} render={(props) => (isAuth ? <Component {...props} /> : <Redirect to="/login" />)} />;
};
